import { useEffect, useState } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { LoadingIndicator, Tab, Tabs, Tooltip } from '@thermon-platforms/thermon-ui-core';
import Upload from './upload';
import api from 'util/api';


function Modal({device, close, dismiss}) {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [confirmImage, setConfirmImage] = useState(null);

  function queryImages() {
    setLoading(true);
    api(`/iso/${device.model.id}`)
      .then(async res => {
        const data = await res.json();
        setImages(data?.isos);
      })
      .catch(() => {/* no-op */})
      .finally(() => {
        setLoading(false);
      });
  }

  function downloadImage(image) {
    const link = document.createElement('a');
    link.href = 'data:application/pdf;base64,' + image.isoImage;
    link.download = image.isoName;
    link.click();
  }

  function deleteImage(image) {
    api(`/iso/${image.isoId}`, {method: 'DELETE'})
      .then(() => {
        setImages(prevImages => prevImages.filter(img => img !== image));
        setConfirmImage(null);
      });
  }

  useEffect(() => {
    queryImages();
  }, []);

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3><Trans>ISOs for</Trans>: <strong>{device.model.name}</strong></h3>
      </header>
      <section>
        <Tabs>
          <Tab name={t`ISOs`}>
            <LoadingIndicator show={loading} />
            {!loading && images.length ? (
              confirmImage ? (
                <div className="device-images-confirm">
                  <p>
                    <Trans>
                      Are you sure you want to delete ISO "{confirmImage.isoName}"?
                    </Trans>
                  </p>
                  <div className="controls">
                    <button onClick={() => setConfirmImage(null)}>
                      <Trans>Cancel</Trans>
                    </button>
                    <button
                      className="danger"
                      onClick={() => deleteImage(confirmImage)}
                    >
                      <Trans>Yes, delete</Trans>
                    </button>
                  </div>
                </div>
              ) : (
                <ul className="device-images">{images.map((image, i) =>
                  <li key={`image-${i}`}>
                    <div className="info">
                      <div className="name">
                        {image.isoName}
                      </div>
                      <div className="controls">
                        <button
                          className="download"
                          data-tooltip-content={t`Download`}
                          data-tooltip-id="iso-tooltip"
                          onClick={() => downloadImage(image)}
                        >
                          <Trans>Download ISO</Trans>
                        </button>
                        <button
                          className="danger delete"
                          data-tooltip-content={t`Delete`}
                          data-tooltip-id="iso-tooltip"
                          onClick={() => setConfirmImage(image)}
                        >
                          <Trans>Delete ISO</Trans>
                        </button>
                      </div>
                    </div>
                    <iframe
                      src={'data:application/pdf;base64,' + image.isoImage}
                      width="100%"
                      height="240"
                      allow="fullscreen"
                    ></iframe>
                  </li>
                )}</ul>
              )
            ) : (
              <p><Trans>No ISOs found</Trans></p>
            )}
          </Tab>
          <Tab name={t`Upload`}>
            <Upload path={`/iso/${device.model.id}`} onUpload={queryImages} />
          </Tab>
        </Tabs>
        <Tooltip id="iso-tooltip" place="bottom-end" />
      </section>
      <footer>
        <button onClick={close}>
          <Trans>Close</Trans>
        </button>
      </footer>
    </I18nProvider>
  )
}

export default Modal;
